export default "__VITE_ASSET__DvhdIrvv__"